/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"BynblL":["Official Digital SAT® Prep"],"xNDNH2":["Maximize your score with free Official Digital SAT<0>®</0> Prep"],"SbnBYl":["Official"],"KRzqes":["We partnered directly with College Board, the creators of the digital SAT, to help you focus on the exact skills you need to succeed on the test."],"jijeT/":["Interactive"],"LSENgJ":["Sharpen your skills with our library of thousands of practice questions, videos, lessons, and hints plus test-taking tips and strategies."],"pJRhbE":["High Quality"],"CjQ2he":["Prep for every section of the digital SAT with guidance from Khan Academy’s team of math, reading, and writing experts."],"2POOFK":["Free"],"jgDyiE":["Access all of our digital SAT prep materials for free—anytime, anywhere."],"KjBAkL":["Get ready for test day by practicing with purpose"],"u2qAos":["Sharpen your skills, reduce stress, and feel confident on test day. Here’s how:"],"nmhZqN":["Take a full-length practice test on College Board’s site"],"YClZxm":["Learn and practice your skills on Khan Academy"],"Pxq40a":["A student diligently preparing for the digital SAT"],"NP04PX":["Encourage your students to download Bluebook™ and get familiar with the digital SAT test content and platform."],"daJmUy":["SAT practice on Khan Academy is world-class SAT prep that’s effective and 100% free. Encourage your teen to get a head start and practice today!"],"bZ9yn6":["The best way to practice for the digital SAT is free for <0><1/>everyone.</0>"],"Kzy2d8":["More Info"],"sW5OjU":["required"],"LLAa/9":["Optional"],"y5p2bQ":["Did you know?"],"XnGvPC":["Regardless of who you are, mastering even just one more skill on Khan Academy results in learning gains."],"I4wbpi":["Learners have spent ",["actualMinutes"]," billion minutes learning on Khan Academy. ",["approxMinutes"]," billion minutes is equivalent to ",["actualYears"]," years."],"gDr74c":["Educators, learn more"],"RzkD8z":["Parents, learn more"],"4JEWui":["For educators"],"VqQ97I":["For parents"],"O1h2Xs":["Let's go"],"sKIpiM":["A partnership between College Board and Khan Academy"],"fdqR3g":["The inside scoop on the new digital SAT"],"PvHFXC":["Get a sneak peek into the new digital SAT. Learn more about the test format and the best way to prepare."],"zwWKhA":["Learn more"],"yH3Oph":["“It was a lot less stressful than the paper SAT because of it being only around 2 hours and because you don’t have to bubble answers anymore which was quite tedious before.”"],"/PNNIS":["Sarah O. | Casablanca, Morocco"],"5xMJ2Q":["Digital SAT Pilot Student"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["ur","zh-hant","sk","sgn-us","lol","is","fv","en-x-rtl","zu","xh","th","te","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["zh-hans","vi","uk","sr","ro","pt","pl","pa","or","nb","ko","km","ka","hy","hi","fr","de","bn","bg","uz","ta","sv","rw","ru","pt-pt","nl","my","mr","mn","lv","lt","ky","kn","kk","ja","it","id","hu","gu","el","da","cs","as","az","ar"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
